import { openBlock as e, createElementBlock as o, createElementVNode as t } from "vue";
import { _ as n } from "../../_plugin-vue_export-helper-dad06003.js";
const c = {}, l = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 20 20"
}, r = /* @__PURE__ */ t("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.168l3.71-3.938a.75.75 0 1 1 1.08 1.04l-4.25 4.5a.75.75 0 0 1-1.08 0l-4.25-4.5a.75.75 0 0 1 .02-1.06Z",
  clipRule: "evenodd"
}, null, -1), s = [
  r
];
function _(d, i) {
  return e(), o("svg", l, s);
}
const m = /* @__PURE__ */ n(c, [["render", _]]);
export {
  m as default
};
